<template>
  <div id="human" class="main">
    <Hero backimg="background-image:url(/images/hero-human.png)"
      :title="$t('human.banner')"
      sub="" />

    <div class="color-change">
      <div class="text-center wrap-1500">
        <div class="base-title ft-30">{{$t('human.content.title')}}</div>
<!--        <div class="base-sub ff-dr ft-16">-->
<!--          What is the most important in the 21st century?-->
<!--        </div>-->
        <div class="base-sub-2 ft-14">{{$t('human.content.sub')}}</div>

        <!-- <div class="img-uncover base1">
          <img src="/images/base1.png" alt="">
        </div> -->
      </div>

      <div class="base-wrap wrap-1500 align-center">
        <div class="item left">
          <div class="img-uncover human1">
            <img src="/images/human1.png" alt="">
          </div>
        </div>

        <div class="item right base-title-wrap">
          <div class="base-title ft-30">{{$t('human.content.text')}}</div>
<!--          <div class="base-sub ff-br ft-16">-->
<!--            Both ability and political integrity, with morality first-->
<!--          </div>-->
          <div class="base-sub-2 ft-14">
            {{$t('human.content.info')}}
          </div>
        </div>
      </div>

      <div class="text-center wrap-1500">
        <div class="base-title ft-30">{{$t('human.title1')}}</div>
<!--        <div class="base-sub ff-dr ft-16">-->
<!--          Staff style-->
<!--        </div>-->
      </div>

      <div class="wrap-1500">
        <div class="productlist">
          <div class="productitem"
            v-for="item in items"
            :key="item.ID">
            <StaffItem
              :id="item.ID"
              :img="item.SMALLPIC"
              :title="item.PRONAME"
              :info="item.MS"
              :date="item.NOTETIME" />
          </div>
        </div>
      </div>

      <div class="text-center wrap-1500">
        <div class="base-title ft-30">{{$t('human.title2')}}</div>
<!--        <div class="base-sub ff-dr ft-16">-->
<!--          Jobs-->
<!--        </div>-->
      </div>

      <Swipe2 />
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue'
import StaffItem from '@/components/StaffItem.vue'
import Swipe2 from '@/components/Swipe2.vue'
import { getStaffUrl } from '@/util/url.js'
import axios from 'axios'

// const mockData = [
//   {
//     ID: '0',
//     SMALLPIC: '/images/human2.png',
//     PRONAME: '今日食品2019年年度大会在宁波香格里拉...',
//     MS: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     NOTETIME: '2019.3.1'
//   },
//   {
//     ID: '1',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '2',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '3',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '4',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '5',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '6',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   },
//   {
//     ID: '7',
//     img: '/images/human2.png',
//     title: '今日食品2019年年度大会在宁波香格里拉...',
//     info: '为了进一步增强员工的团队凝聚力和战斗力，在开展业绩提升培训的同时，公司也组织大家进行了一次大连深度游玩',
//     date: '2019.3.1'
//   }
// ]

export default {
  components: {
    Hero,
    StaffItem,
    Swipe2
  },

  data () {
    return {
      items: []
    }
  },

  mounted () {
    document.title = `${this.$t('nav.human')}-${this.$t('title')}`
    this.$nextTick(() => {
      if (window.scrollBar) window.scrollBar.scrollTop = 0

      // setTimeout(() => {
      //   this.loader.hide()
      // }, 300)
    })

    this.fechData()
  },

  methods: {
    fechData () {
    //   setTimeout(() => {
    //     this.items = mockData
    //   }, 1000)

      const url = getStaffUrl(this.$store.state.lang)
      axios.get(url).then(res => {
        // console.log(res)
        if (res && res.data && res.data.proarr && res.data.proarr.length > 0) {
          this.items = res.data.proarr
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main, .color-change {
  background: linear-gradient(#cae6f9, #cae6f9, #fff);
}

.wrap-1500 {
  max-width: 1500px;
  width: 100%;
  margin: 0 auto;
}

.text-center {
  text-align: center;
  padding: 100px 30px 30px 30px;
  width: 100%;
  margin: 0 auto;

  // .img-uncover {
  //   margin-top: 48px;
  // }
}

.base-title {
  line-height: 60px;
  color: #09192a
}
.base-sub {
  line-height: 32px;
  color: #82a6be;
}
.base-sub-2 {
  line-height: 32px;
  color: #82a6be;
}

.base-wrap.align-center {
  padding: 40px 30px;
  align-items: center;
}
.base-wrap {
  padding: 40px 30px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .down {
    margin-top: 120px;
  }
  .item {
    flex: 1;
  }
  .left {
    margin-right: 32px;

    .img-uncover img {
      width: 100%;
    }
  }
  .right {
    margin-left: 32px;
  }

  .base-info {
    line-height: 28px;
    color: #3c546e;
  }
}

.productlist {
  padding: 30px 0;
  display: flex;
  flex-wrap: wrap;
}
.productitem {
  width: 25%;
  padding: 32px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media(max-width: 768px){
  .base-wrap{
    flex-wrap: wrap;
    .item{
      width: 100%;
      flex: auto;
      &.left{
        margin-right: 0;
      }
      &.right{
        margin-left: 0;
      }
    }
  }
  .productitem{
    width: 100%;
  }
}
</style>
